import React, {PureComponent} from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col } from 'reactstrap';
import NewIcon from 'mdi-react/MoneyIcon'
import LetterIcon from 'mdi-react/EnvelopeIcon'


const data = [{ value: 68, fill: '#ff4861' },
    { value: 32, fill: '#eeeeee' }];

export default class PieScreen extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            //modal: false
        };
    }

    render() {

        let value = 0;

        if(this.props.data && this.props.data[0] && this.props.data[0].value) {
            value = this.props.data[0].value;
        }

        return (
            <Col md={12} xl={6} lg={6} sm={12} xs={12}>
                <Card>
                    <CardBody className="dashboard__health-chart-card">
                        {/*<div className="card__title">
                            <h5 className="bold-text">TEST</h5>
                        </div>*/}
                        <div className="dashboard__health-chart">
                            <ResponsiveContainer height={360}>
                                <PieChart>
                                    <Pie data={this.props.data} dataKey="value" cy={170} innerRadius={160} outerRadius={170} />
                                </PieChart>
                            </ResponsiveContainer>
                            <div className="dashboard__health-chart-info">
                                {this.props.type === 'new' ? <NewIcon style={{ fill: '#f6da6e', width: "80px", height: "80px", marginTop: "-50px"}} /> :
                                    <LetterIcon style={{ fill: '#70bbfd', width: "80px", height: "80px", marginTop: "-50px"}} /> }
                                <p className="dashboard__health-chart-number" style={{marginTop: '10px',fontSize: '50px'}}>{value}</p>
                            </div>
                        </div>
                        <p className="dashboard__goal" style={{fontSize: '30px'}}>{this.props.text}</p>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}